const buildPartnerAreaQueryString = (partnerArea) => {
    const { name } = partnerArea;
    const partnerAreaQsa = `&partnerArea=${name}`;
    return partnerAreaQsa;
}

export default buildPartnerAreaQueryString;